import vue from 'vue';
import ethereumJsAbi from 'ethereumjs-abi';

vue.prototype.$ethereumJsAbi = ethereumJsAbi;

export default ethereumJsAbi;
